<template>
  <div>
    <headBox title="员工产品模板"></headBox>
    <div class="content">
      <div class="top-tools">
        <div class="list-top">
          <label class="title">模板名称</label>
          <el-input placeholder="请输入" size="small" v-model.trim="searchParams.name" clearable></el-input>
          <el-button size="small" class="org-btn search-btn" @click="searchAjax()">查询</el-button>
          <el-button class="addbtn org-btn is-plain" type="primary" size="small" @click="modifyTemplate('add', '')" plain>+ 新建模板</el-button>
        </div>
      </div>
      <el-table style="width: 100%" :data="tableData" border class="list-table" v-loading="listLoading" tooltip-effect="dark">
        <el-table-column prop="name" min-width="200px" label="模板名称/code" show-overflow-tooltip>
          <template slot-scope="scope">
            <tooltip :txt-info="scope.row.name"></tooltip>
            <div class="info-text">{{ scope.row.code }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="userNum" min-width="100px" label="使用员工" show-overflow-tooltip>
          <template slot-scope="scope">
            <span
              class="num-href"
              @click="$refs.userStaffRef.open({ name: scope.row.name, productTemplateCode: scope.row.code, mechanId: scope.row.mechanId })"
              >{{ scope.row.userNum }}</span
            >
          </template>
        </el-table-column>
        <el-table-column prop="productNum" min-width="100px" label="模板产品" show-overflow-tooltip>
          <template slot-scope="scope">
            <span class="num-href" @click="goTemplateProduct(scope.row)">{{ scope.row.productNum }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="isSyncNewProduct" min-width="160px" label="是否自动同步新产品" show-overflow-tooltip>
          <template slot-scope="scope">
            <div :class="scope.row.isSyncNewProduct == 1 ? 'green-tag' : 'red-tag'">{{ scope.row.isSyncNewProduct == 1 ? '是' : '否' }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="remark" min-width="250px" label="备注" show-overflow-tooltip></el-table-column>
        <el-table-column label="所属组织" width="130">
          <template slot-scope="scope">
            <span>{{ scope.row.mechanName }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" min-width="200px" label="创建时间" show-overflow-tooltip>
          <template slot-scope="scope">{{ scope.row.createTime | timeSubstr(0, 16) }}</template>
        </el-table-column>
        <el-table-column prop="" min-width="180px" label="操作" fixed="right">
          <template slot-scope="scope">
            <el-button-group class="line-btn-box">
              <el-button type="text" size="small" @click="modifyTemplate('edit', scope.row)">编辑</el-button>
              <el-button type="text" size="small" @click="copyTemplate(scope.row)">复制</el-button>
              <el-button type="text" size="small" @click="del(scope.row)">删除</el-button>
            </el-button-group>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="page"
        @size-change="handleSizeChange"
        :current-page.sync="pageNum"
        background
        layout="total, sizes, prev, pager, next, jumper"
        :page-sizes="[10, 20, 30, 40]"
        @current-change="handleCurrentChange"
        :total="total"
      ></el-pagination>
    </div>
    <el-dialog :title="id ? '编辑' : '新建'" :visible.sync="visible" width="440px" custom-class="my-dialog-template editChild" :close-on-click-modal="false">
      <el-form :inline="true" :model="listForm" ref="listFormRef" class="my-form-template editChild" label-width="120px">
        <el-form-item label="模板名称" class="full" prop="name" :rules="$tools.formRule.required('请输入模板名称')">
          <el-input type="text" v-model.trim="listForm.name" placeholder="请输入" clearable></el-input>
        </el-form-item>

        <el-form-item label="归属机构" class="full mechant-input" prop="mechanId" :rules="$tools.formRule.required('请选择')">
          <div v-if="!!id">{{ listForm.mechanName }}</div>
          <el-select v-else class="right-select" v-model="listForm.mechanId" :disabled="!!id" clearable filterable>
            <el-option :label="dept.shortName" :value="dept.id" v-for="(dept, index) in selectList" :key="index"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="备注" class="full" prop="remark">
          <el-input type="textarea" :rows="4" v-model="listForm.remark" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="" class="full radioClass" v-if="btnFlag" prop="isSaveAllProduct">
          <div class="left">
            <span>是否添加全部产品</span>
            <el-popover popper-class="StaffPopOver" placement="top" trigger="hover">
              <span class="wh" slot="reference">
                <i class="icon-wenhao1"></i>
              </span>
              <div class="desc">系统将自动添加商品库里所有产品，您只需选择性的删除部分产品。</div>
            </el-popover>
          </div>
          <el-switch v-model="listForm.isSaveAllProduct" style="width: auto" active-color="#FD9201" active-value="1" inactive-value="0"></el-switch>
        </el-form-item>
        <el-form-item label="" class="full radioClass" prop="isSyncNewProduct">
          <div class="left">
            <span>是否自动同步新产品</span>
            <el-popover popper-class="StaffPopOver" placement="bottom" trigger="hover">
              <span class="wh" slot="reference">
                <i class="icon-wenhao1"></i>
              </span>
              <div class="desc">当有新产品上架后系统将自动同步到该模板中。</div>
            </el-popover>
          </div>
          <el-switch v-model="listForm.isSyncNewProduct" style="width: auto" active-color="#FD9201" active-value="1" inactive-value="0"></el-switch>
        </el-form-item>
      </el-form>
      <div class="dialog-footer">
        <el-button type="primary" plain @click="visible = false">取消</el-button>
        <el-button type="primary" class="bgBtn" @click="save" v-if="!btnFlag">保存</el-button>
        <el-button type="primary" @click="nextPage" :loading="nextBtnLoading" v-if="btnFlag">下一步</el-button>
      </div>
    </el-dialog>
    <userStaff ref="userStaffRef"></userStaff>
    <selectTemplate ref="selectTemplateRef" @reload="getList()"></selectTemplate>
    <addProduct ref="addProductRef" @reload="getList()"></addProduct>
    <templateProduct ref="templateProductRef" @reload="getList()"></templateProduct>
  </div>
</template>
<script>
import userStaff from './components/useStaffDialog.vue'
import selectTemplate from './components/selectTemplate.vue'
import addProduct from './components/addProduct.vue'
import templateProduct from './components/templateProduct.vue'
import headBox from "@/components/head.vue";
import { pageTool } from '@/api/mixins'
import tooltip from "@/components/tooltip";
export default {
  mixins: [pageTool],
  data: () => ({
    userInfo: {},
    id: '',
    btnFlag: false,// 新增时为true
    visible: false,
    name: '',
    selectList: [],
    listForm: {},
    nextBtnLoading: false,
  }),
  components: {
    headBox,
    userStaff,
    selectTemplate,
    addProduct,
    tooltip,
    templateProduct
  },
  created() {
    this.userInfo = this.$tools.getLocal('userinfo')
    this.nextBtnLoading = false
    this.initListAjax('/master/productTemplate/queryList')
    this.getChildList()
  },
  methods: {
    // 获取机构/员工列表
    getChildList() {
      this.$http({
        url: '/master/mechan/queryChildList',
        type: 'PUT',
        params: {
          includeFirst: '1'
        },
      }).then((res) => {
        if (res.httpCode == 200) {
          this.selectList = res.data
        }
      })
    },
    // 复制
    copyTemplate(item) {
      this.$confirm('确认复制此模板？', '', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
      }).then(() => {
        this.$http({
          url: '/master/productTemplate/copyTemplate',
          type: 'POST',
          params: {
            id: item.id
          }
        }).then(res => {
          if (res.httpCode == 200) {
            this.$message.success('复制成功')
            this.getList()
          }
        })
      })
    },
    goTemplateProduct(row) {
      this.$refs.templateProductRef.open(row.id)
    },
    // 编辑/新增模板
    modifyTemplate(flag, item) {
      this.id = ''
      this.visible = true
      this.btnFlag = false
      this.$nextTick(() => {
        this.$refs.listFormRef.resetFields()
        if (flag == 'add') {
          this.btnFlag = true
          this.listForm = {
            isSyncNewProduct: '1',
            isSaveAllProduct: '1',
          }
        }
        if (flag == 'edit') {
          this.id = item.id
          this.listForm = {
            id: item.id,
            name: item.name,
            remark: item.remark,
            mechanId: item.mechanId,
            isSyncNewProduct: item.isSyncNewProduct,
            mechanName: item.mechanName
          }
        }
      })
    },
    // 删除
    del(row) {
      if (row.isDefault == 1) {
        this.$message.warning('系统默认产品模板不支持删除！')
        return
      }
      if (row.userNum && row.userNum != 0) {
        this.$message.warning('该产品模板已有员工使用，暂不支持删除！')
        return
      }
      this.$confirm('此操作将永久删除该模板，是否继续？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        this.$http({
          url: '/master/productTemplate/delete',
          type: 'DELETE',
          params: {
            id: row.id
          }
        }).then(res => {
          if (res.httpCode == 200) {
            this.$message({
              type: 'success',
              message: '删除成功！'
            });
            this.searchAjax()
          }
        })
      }).catch(e => { })
    },
    // 保存
    save() {
      this.$refs['listFormRef'].validate(vaild => {
        if (vaild) {
          this.$http({
            url: '/master/productTemplate/saveTemplate',
            type: 'POST',
            params: this.listForm
          }).then(res => {
            if (res.httpCode == 200) {
              this.$message.success('保存成功')
              this.visible = false
              this.searchAjax()
            }
          }).catch(e => { })
        }
      })
    },
    // 下一步
    nextPage() {
      this.$refs['listFormRef'].validate(vaild => {
        if (vaild) {
          this.nextBtnLoading = true
          // 保存模板
          this.$http({
            url: '/master/productTemplate/saveTemplate',
            type: 'POST',
            params: this.listForm
          }).then(res => {
            // 关闭当前弹窗
            this.visible = false
            this.nextBtnLoading = false
            let id = res.data.id
            // 勾选全部产品---进入模板产品列表
            if (this.listForm.isSaveAllProduct == 1) {
              this.$refs.selectTemplateRef.open(id, this.listForm.isSaveAllProduct)
            } else {
              // 未勾选全部产品---进入新增产品弹窗
              this.$refs.addProductRef.open(id, [], 'childTemplate') // id,当前产品数,页面名称
            }
          }).catch(e => {
            this.nextBtnLoading = false
          })
        }
      })
    },
    // 分页
    handleCurrentChange(val) {
      this.pageNum = val
      this.getList()
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.getList()
    },
  }
}
</script>
<style lang='scss' scoped>
.content {
  background: #ffffff;
  padding: 20px 30px 120px 30px;
  .top-tools {
    margin-bottom: 20px;
    .list-top {
      .el-input {
        width: 20%;
        margin-right: 30px;
      }
      .title {
        font-size: 14px;
        color: #333333;
        margin-right: 10px;
        word-break: keep-all;
      }
      .search-btn {
        font-size: 14px;
        width: 80px;
      }
      .addbtn {
        font-size: 14px;
        margin-left: 20px;
        width: 100px;
      }
    }
  }
  .list-table {
    .info-text {
      font-size: 12px;
      color: #a8adb7;
    }
    &::v-deep {
      .el-table__row {
        height: 50px;
      }
      .cell {
        line-height: 25px;
      }
    }
    .num-href {
      border-bottom: 1px solid #fd9201;
      color: #fd9201;
      cursor: pointer;
      // font-weight: 700;
    }
    .disabled {
      filter: grayscale(1);
      pointer-events: none;
    }
    .green-tag {
      width: 60px;
      height: 24px;
      background: #f6ffec;
      border: 1px solid #b7ea8f;
      border-radius: 4px;
      color: #22bc02;
      margin: auto;
      line-height: 24px;
    }
    .red-tag {
      width: 60px;
      height: 24px;
      background: #fff1f0;
      border: 1px solid #fda39e;
      border-radius: 4px;
      color: #f8585d;
      margin: auto;
      line-height: 24px;
    }
  }
}
</style>
<style lang="scss">
.StaffPopOver {
  .desc {
    font-size: 12px;
    color: #888888;
    line-height: 20px;
  }
}
.editChild {
  .my-form-template {
    margin-bottom: 5px;
  }

  .mechant-input {
    .is-disabled {
      input {
        border: none;
        background-color: #fff;
        color: #333;
        cursor: default !important;
      }
      .el-icon-arrow-up {
        display: none;
      }
    }
  }
  .el-form-item.is-error .el-input__validateIcon {
    display: none;
  }
  .el-form-item .el-input__validateIcon {
    display: none;
  }
  .radioClass {
    margin-bottom: 20px;
    .left {
      vertical-align: middle;
      width: 160px;
      display: inline-block;
      text-align: right;
    }
    .wh {
      display: inline-block;
      width: 14px;
      height: 14px;
      border-radius: 50%;
      text-align: center;
      line-height: 12px;
      vertical-align: middle;
      background: #fff;
      color: #afafaf;
      margin-left: 3px;
      cursor: pointer;
      font-size: 14px;
      margin-right: 12px;
    }
  }
}
</style>